import { StaticTreeDataProvider } from "react-complex-tree";

import styled from "styled-components";

export const TreeItemMain = styled.div`
    display: flex;
    align-items: center;
    height: 32px;
    margin: 0;
    padding: 0 2px;
    width: 100%;
    border-radius: 2px;
    background-color: ${(props) =>
        props.isDraggingOver
            ? "var(--color-ButtonHover4)"
            : props.isSelected
            ? "var(--color-ButtonHover4)"
            : "transparent"};
    &:hover {
        background-color: var(--color-ButtonHover4);
    }
`;

export const TreeItemContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding-left: ${(props) => (props.depth < 1 ? "0px" : "24px")};
`;

export const TreeItemArrow = styled.div`
    width: 20px;
    height: 20px;

    &:hover {
        cursor: pointer;
    }
`;

export const TreeItemTitle = styled.div`
    display: flex;
    align-items: center;
    overflow: hidden;
    flex: 1;
    cursor: pointer;
`;

export const TreeItemKnob = styled.div`
    width: 20px;
    height: 20px;
    visibility: hidden;
    ${TreeItemMain}:hover & {
        visibility: visible;
    }
    &:hover {
        cursor: pointer;
    }
`;

export const TreeItemChildren = styled.div`
    width: 100%;
`;

const allRefsTreeData = {
    root: {
        index: "root",
        name: "root",
        children: ["all"],
    },
    all: {
        index: "all",
        name: "모든 참고문헌",
        children: [],
        isFolder: false,
    },
};

export const allRefsTreeDataProvider = new StaticTreeDataProvider(allRefsTreeData, (item, name) => ({
    ...item,
    name,
}));
